import { InitialPriceFilterState } from '@allesauto/utils/consts';
import { isEmptyObject } from '@allesauto/utils/funcs';
import isArray from 'lodash/isArray';
import reduceReducers from 'reduce-reducers';
import { AnyAction, combineReducers } from 'redux';

import { RouteFilter } from '@/features/PCP/types';
import {
  DELETE_ALL_FILTERS,
  FuelFilterStateProps,
  SET_ALL_FILTERS,
  SET_ALL_FILTERS_SETFLAG,
  SET_PREVIOUS_ROUTE_FILTER,
} from '@/store/redux/actions/pages/pcp';
import makeModelReducer, {
  initialState as makeModelInitialState,
  MakeModelFilterData,
  MakeModelFilterState,
} from '@/store/redux/slices/pages/pcp/filters/makeModel';

import FacetsState, { FacetsStateProps } from './facets';
import BodyColorsState, { InitialBodyColorsState } from './filters/bodyColors';
import { BodyColorsStateProps } from './filters/bodyColors/index';
import DriveState, {
  DriveStateProps,
  InitialDriveState,
} from './filters/drive';
import EmissionFilterState, {
  EmissionFilterStateProps,
  InitialEmissionFilterState,
} from './filters/emission';
import EquipmentState, {
  InitialEquipmentFilterState,
} from './filters/equipment';
import { EquipmentFilterStateProps } from './filters/equipment/index';
import FuelFilterState, { InitialFuelFilterState } from './filters/fuel';
import InteriorFilterState, {
  InitialInteriorFilterState,
  InteriorFilterStateProps,
} from './filters/interior';
import LocationState, {
  InitialLocationState,
  LocationStateProps,
} from './filters/location';
import MerchantLocationState, {
  InitialMerchantLocationFilterState,
  MerchantLocationFilterStateProps,
} from './filters/merchantLocation';
import PriceFilterState from './filters/price';
import { PriceFilterStateProps } from './filters/price/index';
import VehicleCondtitionFilterState, {
  InitialVehicleConditionFilterState,
  VehicleConditionStateProps,
} from './filters/vehicleCondition/index';
import VehicleTypeFilterState, {
  InitialVehicleTypeFilterState,
  VehicleTypeFilterStateProps,
} from './filters/vehicleType';
import PCPState, { PCPStateProps } from './page/index';

export type PCPFilterState =
  | BodyColorsStateProps
  | LocationStateProps
  | MerchantLocationFilterStateProps
  | EquipmentFilterStateProps
  | PriceFilterStateProps
  | MakeModelFilterState
  | DriveStateProps
  | InteriorFilterStateProps
  | FuelFilterStateProps
  | EmissionFilterStateProps
  | VehicleTypeFilterStateProps
  | VehicleConditionStateProps;

// type PCPFilterStateWithFilterCount = Exclude<
//   PCPFilterState,
//   | EquipmentFilterStateProps
//   | PriceFilterStateProps
//   | DriveStateProps
//   | FuelFilterStateProps
//   | EmissionFilterStateProps
// >;

export interface IPCPFiltersState {
  bodyColors: BodyColorsStateProps;
  location: LocationStateProps;
  merchantLocation: MerchantLocationFilterStateProps;
  equipment: EquipmentFilterStateProps;
  priceRange: PriceFilterStateProps;
  makeModel: MakeModelFilterState;
  drive: DriveStateProps;
  interior: InteriorFilterStateProps;
  fuelType: FuelFilterStateProps;
  emission: EmissionFilterStateProps;
  vehicleType: VehicleTypeFilterStateProps;
  vehicleCondition: VehicleConditionStateProps;
}

export const INITIAL_PCP_FILTER_STATE: IPCPFiltersState = {
  bodyColors: InitialBodyColorsState,
  location: InitialLocationState,
  merchantLocation: InitialMerchantLocationFilterState,
  equipment: InitialEquipmentFilterState,
  priceRange: InitialPriceFilterState,
  makeModel: makeModelInitialState,
  drive: InitialDriveState,
  interior: InitialInteriorFilterState,
  fuelType: InitialFuelFilterState,
  emission: InitialEmissionFilterState,
  vehicleType: InitialVehicleTypeFilterState,
  vehicleCondition: InitialVehicleConditionFilterState,
};

export interface PCPCombinedState {
  page: PCPStateProps;
  facets: FacetsStateProps;
  filters: IPCPFiltersState;
  previousRouteFilter: RouteFilter;
  allFiltersSetFlag: boolean;
}

const handleDeleteAllFilters = () => INITIAL_PCP_FILTER_STATE;

//TODO: Find a better solutin - Kevin's help
const handleSetAllFilters = (state: IPCPFiltersState, payload: any) => {
  return Object.entries(payload).reduce(
    (previousValue, [filterKey, filterValue]) => {
      if (filterKey === 'makeModel') {
        if (isArray(filterValue) && filterValue.length !== 0) {
          const valueFiltered = {
            data: [] as MakeModelFilterData[],
          };

          filterValue.forEach((value, i) => {
            valueFiltered.data.push({
              makes: {
                selected: '',
              },
              models: {
                loading: false,
                data: [],
                selected: '',
              },
            });
            if (!isEmptyObject(value.makes)) {
              valueFiltered.data[i].makes.selected = value.makes;
            }

            if (!isEmptyObject(value.models)) {
              valueFiltered.data[i].models.selected = value.models;
            }
          });

          filterValue = valueFiltered;
        } else {
          filterValue = [{}];
        }
      } else if (filterKey === 'bodyColors') {
        filterValue = { colors: filterValue };
      }

      return {
        ...previousValue,
        [filterKey]: {
          ...previousValue[filterKey as keyof IPCPFiltersState],
          ...(filterValue as object),
          ...('filterCount' in
            previousValue[filterKey as keyof IPCPFiltersState] && {
            filterCount: Object.values(filterValue as object)[0].length,
          }),
        },
      };
    },
    state
  );
};

const handleSetPreviousRouteFilter = (state: RouteFilter, payload: any) => ({
  ...payload,
});

//eslint-disable-next-line @typescript-eslint/no-unused-vars
const handleSetFiltersSetFlag = (state: boolean) => true;

export const filtersReducer = (
  state: IPCPFiltersState = INITIAL_PCP_FILTER_STATE,
  action: AnyAction
) => {
  if (action.type === DELETE_ALL_FILTERS) {
    return handleDeleteAllFilters();
  }
  if (action.type === SET_ALL_FILTERS) {
    return handleSetAllFilters(INITIAL_PCP_FILTER_STATE, action.payload);
  }
  return state;
};

const previousRouteFilterReducer = (
  state: RouteFilter = {},
  action: AnyAction
) => {
  if (action.type === SET_PREVIOUS_ROUTE_FILTER) {
    return handleSetPreviousRouteFilter(state, action.payload);
  }
  return state;
};

const allFiltersSetFlagReducer = (state = false, action: AnyAction) => {
  if (action.type === SET_ALL_FILTERS_SETFLAG) {
    return handleSetFiltersSetFlag(state);
  }
  return state;
};

const combinedReducers = combineReducers({
  page: PCPState,
  filters: reduceReducers(
    combineReducers({
      bodyColors: BodyColorsState,
      location: LocationState,
      equipment: EquipmentState,
      merchantLocation: MerchantLocationState,
      priceRange: PriceFilterState,
      makeModel: makeModelReducer,
      drive: DriveState,
      interior: InteriorFilterState,
      fuelType: FuelFilterState,
      emission: EmissionFilterState,
      vehicleType: VehicleTypeFilterState,
      vehicleCondition: VehicleCondtitionFilterState,
    }),
    filtersReducer
  ),
  facets: FacetsState,
  previousRouteFilter: previousRouteFilterReducer,
  allFiltersSetFlag: allFiltersSetFlagReducer,
});

export default combinedReducers;
